<template>
  <div class="container-root">
    <div>
      <div class="header-group">
        <h2 style="margin: 0px; font-weight: bold">STAFF ATTENDANCE</h2>
        <div class="loader" v-if="isLoading || isDownloading"></div>
        <template v-if="!isLoading">
          <button
            class="button dark-blue"
            v-if="canEdit()"
            @click="setOnTime()"
          >
            <div>{{ 'SET ON TIME' }}</div>
          </button>
          <button
            class="button dark-blue"
            v-if="!this.list.isLoading && !isLoading && !isDownloading"
            @click="download()"
          >
            <div>{{ 'DOWNLOAD' }}</div>
          </button>
        </template>
      </div>
      <div style="margin-top: 25px">
        <Table
          ref="table"
          title="Attendance"
          :model="list.table"
          :isLoading="list.isLoading"
          :selectedId.sync="selectedId"
          :filterIndex="1"
        >
          <div class="control-group">
            <div class="control-title">MONTH</div>
            <select class="control" v-model="month.selected">
              <option
                v-for="option in month.data"
                :key="option.id"
                :value="option.id"
              >
                {{ option.name }}
              </option>
            </select>
          </div>
          <div class="control-group">
            <div class="control-title">YEAR</div>
            <!-- <h3 style="margin:0px">{{year.selected}}</h3> -->
            <select class="control" v-model="year.selected">
              <option v-for="(option, optionIdx) in year.data" :key="optionIdx">
                {{ option }}
              </option>
            </select>
          </div>
        </Table>
      </div>
    </div>
    <Notif v-if="notif" :data.sync="notif"></Notif>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import XLSX from 'xlsx';
import { http, utils } from '../digilib_web/core/digitify';
import { constants, regentsUtils } from '../js/regents';
import Table from '../digilib_web/vue/table';
import Notif from '../digilib_web/vue/notif';

export default {
  props: {
    profile: Object
  },
  watch: {
    breadcrumb: {
      handler(n, o) {
        // reset data when home
        if (n.length === 1 && o.length === 2) {
          this.selectedId = -1;
          this.reloadTable();
        }
      }
    },
    'month.selected': {
      handler(n, o) {
        if (n !== o) {
          this.reloadTable();
        }
      }
    },
    'year.selected': {
      handler(n) {
        this.reloadTable();
      }
    }
  },
  methods: {
    canEdit() {
      return this.profile.role === 'admin';
    },
    setOnTime() {
      let m = this.month.selected;
      let y = this.year.selected;

      if (confirm(`Do you want to set on time ${m}/${y} for all employees ?`)) {
        this.list.isLoading = true;

        http.get(`employees/set-on-time/${m}/${y}`).then(json => {
          console.log(json);
          this.list.isLoading = false;
          let msg = json.success ? 'Success' : 'Failed. Something went wrong';
          alert(msg);
        });
      }
    },
    download() {
      let m = this.month.selected;
      let y = this.year.selected;
      let excelData = [];
      let tableItems = this.$refs.table.tableItems;
      tableItems.forEach(item => {
        let r = this.list.items.find(x => x.id === item.id);
        excelData.push(r);
      });
      let ws = XLSX.utils.json_to_sheet(excelData);
      let wb = XLSX.utils.book_new();
      // console.log(ws, wb)
      XLSX.utils.book_append_sheet(wb, ws, 'data');
      XLSX.writeFile(wb, `attendance-${m}-${y}.xlsx`);
    },
    reloadTable() {
      this.selectedId = -1;
      this.list.isLoading = true;
      // get the employees first
      http
        .get(
          `employees/attendance/monthly/${this.month.selected}/${
            this.year.selected
          }`
        )
        .then(json => {
          this.list.items = [];
          json.data.forEach(row => {
            if (row.employee_name === 'Jim') return;
            let item = this.list.items.find(x => x.id === row.id_employee);
            if (!item) {
              item = {
                id: row.id_employee,
                employee_name: row.employee_name,
                department: row.department,
                onTime: 0,
                late: 0,
                sickness: 0,
                earlyBefTwo: 0,
                earlyAfterTwo: 0,
                excuse: 0,
                absent: 0
              };
              this.list.items.push(item);
            }
            let deductionData = regentsUtils.attendanceDeduction(row, 11);
            if (deductionData.t === 'On Time') {
              item.onTime++;
            } else if (deductionData.t === 'Late') {
              item.late++;
            } else if (deductionData.t === 'Sickness') {
              item.sickness++;
            } else if (deductionData.t === 'Early Leave Before 2 PM') {
              item.earlyBefTwo++;
            } else if (deductionData.t === 'Early Leave After 2 PM') {
              item.earlyAfterTwo++;
            } else if (deductionData.t === 'Excuse') {
              item.excuse++;
            } else if (deductionData.t === 'Absent') {
              item.absent++;
            }
          });
          // generate the table data
          this.list.table = utils.toTable(this.list.items, {
            employee_name: { title: 'name' },
            department: { title: 'department' },
            onTime: { title: 'On Time' },
            late: { title: 'Late' },
            sickness: { title: 'Sickness' },
            earlyBefTwo: { title: 'Early Leave Before 2' },
            earlyAfterTwo: { title: 'Early Leave After 2' },
            excuse: { title: 'Excuse' },
            absent: { title: 'Absent' }
          });
          this.list.isLoading = false;
        });
    }
  },
  mounted() {
    // set selected month and year
    let m = dayjs();
    this.month.selected = parseInt(m.format('M'), 10);
    this.year.selected = parseInt(m.format('YYYY'), 10);
    this.reloadTable();

    console.log(this.month.selected);
    console.log(this.year.selected);
  },
  data() {
    return {
      countLate: 0,
      isLoading: false,
      isDownloading: false,
      notif: null,
      selectedId: -1,
      selectedModel: null,
      month: {
        data: constants.MONTHS,
        selected: null
      },
      year: {
        data: constants.YEARS,
        selected: null
      },
      list: {
        isLoading: false,
        table: {},
        items: []
      }
    };
  },
  components: {
    Table,
    Notif
  }
};
</script>

<style scoped>
.header-group {
  display: flex;
  justify-content: space-between;
}
</style>
